import { SaveOutlined, WarningAmberOutlined } from "@mui/icons-material";
import { Box, Button, Card, Container } from "@mui/material";
import React, { useMemo } from "react";
import Flx from "../layout/Flx";
import { green, grey } from "@mui/material/colors";
import Txt from "../typography/Txt";
import { isFunction } from "lodash";

const UnsavedChangesAlert = ({
  onCancel,
  onSubmit,
  disabled = false,
  loading = false,
  saveText = "Save Changes",
  text = "You have unsaved changes",
  subText,
  primaryButtonVariant = "contained",
  // primaryButtonColor = "success",
  secondaryButtonVariant = "contained",
  icon = <WarningAmberOutlined className="thin-9" />,
  children,
  hideButtons = false,
  sx,
}) => {
  const styles = useMemo(() => {
    return {
      position: "fixed",
      bottom: "24px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "100%",
      borderRadius: 2,
      color: "#fff",
      background: "#212121eb",
      boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
      backdropFilter: "blur(8px)",
      py: 2,
      zIndex: 11110,
      border: `1px solid ${grey[600]}`,
      ...sx,
    };
  }, [sx]);

  const saveButtonStyles = useMemo(() => {
    return {
      // backgroundColor: `${green[700]} !important`,
      // border: `1px solid ${green[700]} !important`,
      // backgroundColor: "#8fe493ff !important",
      // color: "rgba(255, 255, 255, 1) !important",
    };
  }, []);
  return (
    <Container variant="elevated" maxWidth="md" sx={styles}>
      <Flx fw jb ac wrap gap={1}>
        <Flx ac wrap gap={1}>
          {icon}
          <Flx column>
            <Txt sx={{ fontSize: "16px", fontWeight: 500 }}>{text}</Txt>
            {subText && (
              <Txt sx={{ fontSize: "10px", fontWeight: 400, opacity: 0.7 }}>
                {subText}
              </Txt>
            )}
          </Flx>
          {children}
        </Flx>
        {hideButtons ? null : (
          <Flx gap={1}>
            <Button
              size="large"
              color="error"
              variant={secondaryButtonVariant}
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Box sx={{ background: "#ffffff", borderRadius: "4px" }}>
              <Button
                loading={loading}
                disabled={disabled}
                variant={primaryButtonVariant}
                size="large"
                color="success"
                loadingPosition="end"
                onClick={onSubmit}
                sx={saveButtonStyles}
                type={isFunction(onSubmit) ? "button" : "submit"}
              >
                {loading ? "Saving..." : saveText}
              </Button>
            </Box>
          </Flx>
        )}
      </Flx>
    </Container>
  );
};

export default UnsavedChangesAlert;
